module.exports = "<div class=\"modal-header\">\n  <h4 class=\"modal-title col-xs-8\">{{title}}</h4>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  {{content}}\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary pull-right\" (click)=\"activeModal.dismiss()\">Close</button>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/text-modal/text-modal.component.html
// module id = ./src/app/text-modal/text-modal.component.html
// module chunks = main